import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { batchAddDevice, devicesTypes } from '@blade-sxp/device-management/api/device-management/index';
import { deviceGroupsTree } from '@blade-sxp/device-management/api/device-group-management/index';
import cascaderSelect from '@blade/common/components/cascader-select/index.vue';
import { Message } from 'element-ui';
import axios from 'axios';
let default_1 = class default_1 extends Vue {
    uploadDialogVisible;
    closeImg = require('@blade-sxp/device-management/assets/icon.png');
    imgUrl = require('@blade-sxp/device-management/assets/group.png');
    formData = {
        // groupId: '',
        multipartFile: '',
        deviceType: '',
    };
    props = {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: false, // 只返回该节点的值
    };
    deviceType = [];
    uploadSuccseArr = [];
    groupNameOption = [];
    fileArr = [];
    get rules() {
        return {
            // groupId: [{ required: true, message: `${this.$t('selectGroup')}`, trigger: 'change' }],
            deviceType: [{ required: true, message: `${this.$t('selectDeviceType')}`, trigger: 'change' }],
        };
    }
    get uploadIsabled() {
        return !this.formData.deviceType || this.formData.deviceType === 'VP_GB28181_STD';
    }
    uploadTemplate() {
        if (this.uploadIsabled)
            return;
        axios
            .get(`/api/camera-device-management/api/v1/devices/template`, {
            params: {
                deviceType: this.formData.deviceType,
            },
            responseType: 'blob',
        })
            .then((res) => {
            let blob = new Blob([res.data], {
                type: 'application/vnd.ms-excel',
            });
            let filename = `${this.formData.deviceType}.xlsx`;
            let blobURL = window.URL.createObjectURL(blob);
            let tempLink = document.createElement('a');
            tempLink.style.display = 'none';
            tempLink.href = blobURL;
            tempLink.setAttribute('download', filename);
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank');
            }
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
            this.$message({
                message: this.$t('Exportsuccess').toString(),
                type: 'success',
            });
        });
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    changeSelect(e) { }
    getTypeList() {
        devicesTypes().then((res) => {
            this.deviceType = res;
        });
    }
    deletImg(e) {
        this.fileArr.splice(e, 1);
    }
    handleChange() {
        this.$refs.queueReportCascader.dropDownVisible = false;
    }
    // 处理地区树数据结构
    dealAreaTree(tree) {
        const newTree = tree.map((i) => {
            let children = i.children;
            if ((children && children.length === 0) || !children) {
                delete i.children;
            }
            else {
                this.dealAreaTree(children);
            }
            return i;
        });
        return newTree;
    }
    onImgChoosen(data) {
        const { raw, name, size } = data;
        const maxSize = size / 1024 / 1024 < 20;
        if (!maxSize) {
            Message.error(`${this.$t('uploadFailedSize')}`);
            return;
        }
        if (!/\.(xlsx)$/.test(name)) {
            Message.error(`${this.$t('tip')}`);
            return;
        }
        let obj = {
            name: name,
            file: raw,
            id: this.taskId(),
            size: this.formatFileSize(size),
        };
        this.fileArr.push(obj);
    }
    formatFileSize(fileSize) {
        let temp = 0;
        if (fileSize < 1024) {
            return fileSize + 'B';
        }
        else if (fileSize < 1024 * 1024) {
            temp = fileSize / 1024;
            return `${temp.toFixed(2)}KB`;
        }
        else if (fileSize < 1024 * 1024 * 1024) {
            temp = fileSize / (1024 * 1024);
            return `${temp.toFixed(2)}MB`;
        }
        else {
            temp = fileSize / (1024 * 1024 * 1024);
            return `${temp.toFixed(2)}GB`;
        }
    }
    handleClose() {
        this.$emit('update:uploadDialogVisible', false);
    }
    async submit() {
        const form = this.$refs.deviceForm;
        form.validate((valid) => {
            if (valid) {
                this.upload();
            }
        });
    }
    async upload() {
        if (this.fileArr.length === 0) {
            Message.error(`${this.$t('uploadErr')}`);
            return;
        }
        for (let value of this.fileArr) {
            let formData = new FormData();
            // formData.append('groupId', this.formData.groupId);
            formData.append('deviceType', this.formData.deviceType);
            formData.append('multipartFile', value.file);
            await batchAddDevice(formData).then((res) => {
                this.uploadSuccseArr.push(1);
            });
        }
        if (this.uploadSuccseArr.length === this.fileArr.length) {
            this.handleClose();
            this.$emit('uploadSuccse');
            Message.success(`${this.$t('uploadSuccse')}`);
        }
        else {
            Message.error(`${this.$t('uploadFailed')}`);
        }
    }
    getTree() {
        deviceGroupsTree({ excludeUngrouped: true }).then((res) => {
            //  this.recursiveFunction(res.tree);
            //  this.groupNameOption = res.tree;
            let index = res.tree.findIndex((item) => {
                return item.name === 'Ungrouped Device';
            });
            res.tree.splice(index, 1);
            this.groupNameOption = this.dealAreaTree(res.tree);
        });
    }
    recursiveFunction(trees) {
        let that = this;
        const getStr = function (list) {
            list.forEach(function (row) {
                if (row.children) {
                    that.groupNameOption.push(row);
                    getStr(row.children);
                }
            });
        };
        getStr(trees);
    }
    mounted() {
        this.getTypeList();
        // this.getTree();
    }
};
__decorate([
    Prop()
], default_1.prototype, "uploadDialogVisible", void 0);
default_1 = __decorate([
    Component({
        name: 'uploadModel',
        components: {
            cascaderSelect,
        },
        i18n: {
            messages: {
                en: {
                    Exportsuccess: 'Export Success',
                    cancel: 'cancel',
                    confirm: 'Upload',
                    protocolType: 'Protocol type',
                    uploadDevice: 'Upload Device',
                    content: 'click to upload or drag a file here',
                    tip: 'supported format:.xlsx',
                    tipMax: 'supported format:.xlsx',
                    selectDeviceType: 'Please select protocol type',
                    selectGroup: 'Please select Group name',
                    Group: 'Group Name',
                    type: 'Protocol Type',
                    uploadSuccse: 'Batch adding device configuration files Successfully uploaded and the system is processing them. For details, see Log Center.',
                    uploadFailed: 'upload Failed',
                    uploadFailedSize: 'File size: up to 20m',
                    uploadErr: 'Please upload the file',
                },
                zh: {
                    Exportsuccess: '导出成功',
                    cancel: '取消',
                    confirm: '上传',
                    protocolType: '协议类型',
                    uploadDevice: '上传设备',
                    content: '单击此处上载或拖动文件',
                    selectDeviceType: '请选择协议类型',
                    selectGroup: '请选择组织',
                    tip: '支持文件类型:.xlsx',
                    uploadFailedSize: '文件大小最多20m',
                    Group: '组织名称',
                    type: '协议类型',
                    uploadSuccse: '批量添加设备配置文件已成功上载，系统正在处理这些文件。有关详细信息，请参阅日志中心。',
                    uploadFailed: '上传失败',
                    uploadErr: '请上传文件',
                },
            },
        },
    })
], default_1);
export default default_1;
